export default __webpack_public_path__ + "static/media/saw_sidebar_ebook.7cad69a1.png";